// src/pages/TechStartupsPage.jsx
import React, { useEffect, useState } from "react";
import NavBar from "../components/NavBar";

const MatrixTechStartupsBackground = () => {
  useEffect(() => {
    const canvas = document.getElementById("matrix-techstartups-bg");
    const context = canvas.getContext("2d");

    let width = window.innerWidth,
        height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
    
    const katakana = "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン";
    const latin = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const nums = "0123456789";
    const alphabet = katakana + latin + nums;
    const fontSize = 16;
    const columns = width / fontSize;
    const rainDrops = new Array(Math.floor(columns)).fill(1);
    
    const draw = () => {
      context.fillStyle = "rgba(0,0,0,0.05)";
      context.fillRect(0, 0, width, height);
      context.fillStyle = "#0F0";
      context.font = fontSize + "px monospace";
      for (let i = 0; i < rainDrops.length; i++) {
        const text = alphabet.charAt(Math.floor(Math.random() * alphabet.length));
        context.fillText(text, i * fontSize, rainDrops[i] * fontSize);
        if (rainDrops[i] * fontSize > height && Math.random() > 0.975) {
          rainDrops[i] = 0;
        }
        rainDrops[i]++;
      }
    };
    
    const interval = setInterval(draw, 30);
    const handleResize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    window.addEventListener("resize", handleResize);
    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <canvas
      id="matrix-techstartups-bg"
      className="fixed top-0 left-0 w-full h-full opacity-20 pointer-events-none"
    />
  );
};

const TechStartupsPage = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);
  return (
    <section className="relative min-h-screen bg-gray-900 text-white overflow-hidden">
      <NavBar />
      <MatrixTechStartupsBackground />
      <div className="relative z-10 container mx-auto px-4 py-16">
        {/* Header */}
        <header
          className={`text-center mb-12 transition-all duration-700 ${
            visible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
        >
          <h1 className="text-5xl font-bold font-mono text-green-500 mb-4">
            Tech Startups
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            AIOrbis supports tech startups with agile, scalable solutions that accelerate growth and innovation in fast‑paced markets.
          </p>
        </header>

        {/* Overview Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-4 text-center">
            Overview
          </h2>
          <p className="text-gray-300">
            Our startup solutions are designed to empower emerging companies with cutting‑edge technology, robust infrastructures, and cost‑effective strategies that fuel rapid innovation.
          </p>
        </section>

        {/* Key Benefits Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-4 text-center">
            Key Benefits
          </h2>
          <ul className="list-disc ml-8 text-gray-300 space-y-2">
            <li>Scalable Infrastructure</li>
            <li>Rapid Prototyping & MVP Development</li>
            <li>Agile Methodologies</li>
            <li>Access to Venture‑Backed Resources</li>
            <li>Cost‑Effective Solutions</li>
          </ul>
        </section>

        {/* Call-to-Action */}
        <section className="text-center">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-4">
            Accelerate Your Startup’s Growth
          </h2>
          <p className="text-gray-300 mb-8">
            Let AIOrbis be your strategic partner in transforming innovative ideas into market‑leading products.
          </p>
          <a
            href="/contact"
            className="px-8 py-3 bg-green-600 hover:bg-green-500 text-white font-mono rounded-lg transition-colors duration-300"
          >
            Get in Touch
          </a>
        </section>
      </div>
    </section>
  );
};

export default TechStartupsPage;
